"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["className", "defaultHoverStyling", "path", "viewBox", "style", "size", "children", "isInteractive"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var renderPaths = function renderPaths(path) {
  // if path is array, iterate through it to render multiple paths, otherwise, return single path
  if (Array.isArray(path)) {
    return path.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        d: item,
        key: index
      });
    });
  }
  return /*#__PURE__*/_react["default"].createElement("path", {
    d: path
  });
};

/**
 * Renders SVG icons from paths. Global icon paths are available for usage in
 * `lib/icons/[path-name]`. Select an icon path from the Icon Set above to copy its import statement.
 */
var Icon = function Icon(_ref) {
  var className = _ref.className,
    defaultHoverStyling = _ref.defaultHoverStyling,
    path = _ref.path,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
    style = _ref.style,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24px' : _ref$size,
    children = _ref.children,
    isInteractive = _ref.isInteractive,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!path && !children) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, otherProps, {
    "aria-hidden": "true",
    className: "valign-middle ".concat(className || ''),
    focusable: "false",
    preserveAspectRatio: "xMidYMid meet",
    style: _objectSpread({
      width: size,
      height: size,
      overflow: 'visible',
      fill: 'currentColor'
    }, style),
    viewBox: viewBox
  }), children || renderPaths(path), isInteractive && defaultHoverStyling && /*#__PURE__*/_react["default"].createElement("circle", {
    className: "sb-icon-hover",
    cx: "50%",
    cy: "50%",
    fill: "transparent",
    r: "75%"
  }));
};
Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  /**
   * An SVG icon path string or array of path strings to be rendered.
   * If paths require individual styling, use `IconPath` children instead.
   */
  path: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /**
   * Prop indicating whether or not to use `sb-icon-hover` class
   */
  defaultHoverStyling: _propTypes["default"].bool,
  /**
   * A size for the rendered icon, including a unit (px, em, %, etc). All icons are rendered
   * as squares.
   */
  size: _propTypes["default"].string,
  style: _propTypes["default"].object,
  viewBox: _propTypes["default"].string,
  /**
   * If the icon exists as a button or link, we need to provide feedback on hover and active
   * state for the user. When true, adds a circle with the class `sb-icon-hover`. Using the
   * component `IconButton` will handle this.
   */
  isInteractive: _propTypes["default"].bool
} : {};
Icon.displayName = 'Icon';
var _default = exports["default"] = Icon;